import { render, staticRenderFns } from "./ClipboardButton.vue?vue&type=template&id=76434974&scoped=true&"
import script from "./ClipboardButton.vue?vue&type=script&lang=js&"
export * from "./ClipboardButton.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardButton.vue?vue&type=style&index=0&id=76434974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76434974",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
